import _ from 'lodash';
import stringsSV from '../../l10n/sv.json';
import stringsDA from '../../l10n/da.json';
import stringsNB from '../../l10n/nb.json';
import stringsFI from '../../l10n/fi.json';

const strings = {
  sv: stringsSV,
  da: stringsDA,
  nb: stringsNB,
  fi: stringsFI,
};

export default function translateGenerator(lang = 'sv') {
  return function t(key) {
    let string = _.get(strings[lang], key);

    if (!string) {
      string = `Missing translation: ${key}`;
      console.warn(string);
    }

    return string;
  };
}



// WEBPACK FOOTER //
// ./src/util/translateGenerator.js